<script setup lang="ts">
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';
import type { UserGroup } from '@/services/user_groups';

interface Props {
    open: boolean;
    group: UserGroup | null;
}

interface Emits {
    (e: 'update:open', value: boolean): void;
    (e: 'confirm'): void;
}

defineProps<Props>();
defineEmits<Emits>();
</script>

<template>
    <Dialog :open="open" @update:open="$emit('update:open', $event)">
        <DialogContent
            class="flex flex-col items-center text-center w-fit p-8 !max-w-full"
        >
            <DialogHeader>
                <DialogTitle>Delete group</DialogTitle>
            </DialogHeader>
            <DialogDescription>
                Are you sure you want to delete the group "{{ group?.name }}"?
            </DialogDescription>
            <div class="flex gap-4 items-center">
                <Button variant="destructive" @click="$emit('confirm')">
                    Delete
                </Button>
                <Button
                    variant="secondary"
                    @click="$emit('update:open', false)"
                >
                    Cancel
                </Button>
            </div>
        </DialogContent>
    </Dialog>
</template>
